module.exports = "images/culturebox.15aeee74.png";